import React from 'react';
import { Editor } from '@tiptap/react';
import {
  FormatBold,
  FormatItalic,
  FormatListBulleted,
  FormatListNumbered,
  Title,
} from '@mui/icons-material';

import { MenuButton } from './MenuButton/MenuButton';
import { LinkMenuButton } from './LinkMenuButton/LinkMenuButton';
import classes from './MenuContent.module.scss';

type MenuContentProps = {
  editor: Editor;
};

export const MenuContent = ({ editor }: MenuContentProps) => {
  const toggleBold = () => {
    editor.chain().focus().toggleBold().run();
  };

  const toggleItalic = () => {
    editor.chain().focus().toggleItalic().run();
  };

  const toggleBulletList = () => {
    editor.chain().focus().toggleBulletList().run();
  };

  const toggleOrderedList = () => {
    editor.chain().focus().toggleOrderedList().run();
  };

  const toggleHeading = () => {
    editor.chain().focus().toggleHeading({ level: 1 }).run();
  };

  return (
    <div className={classes.menuContainer}>
      <MenuButton
        onClick={toggleBold}
        isActive={editor.isActive('bold')}
        tooltip="Bold"
        icon={<FormatBold fontSize="small" />}
      />
      <MenuButton
        onClick={toggleItalic}
        isActive={editor.isActive('italic')}
        tooltip="Italic"
        icon={<FormatItalic fontSize="small" />}
      />
      <MenuButton
        onClick={toggleHeading}
        isActive={editor.isActive('heading')}
        tooltip="Heading"
        icon={<Title fontSize="small" />}
      />
      <MenuButton
        onClick={toggleBulletList}
        isActive={editor.isActive('bulletList')}
        tooltip="Bullet List"
        icon={<FormatListBulleted fontSize="small" />}
      />
      <MenuButton
        onClick={toggleOrderedList}
        isActive={editor.isActive('orderedList')}
        tooltip="Numbered List"
        icon={<FormatListNumbered fontSize="small" />}
      />
      <LinkMenuButton editor={editor} />
    </div>
  );
};
